import { captureTrafficSourceFromQuery } from '@/utils/channelSource.js';

export default defineNuxtPlugin(() => {
	const router = useRouter();

	const captureFromRoute = (query: Record<string, unknown> = {}) => {
		captureTrafficSourceFromQuery(query as { source?: string });
	};

	captureFromRoute(useRoute().query as Record<string, unknown>);

	router.afterEach(to => {
		captureFromRoute(to.query as Record<string, unknown>);
	});
});
